module.exports = __webpack_public_path__ + "img/Pot1.371d1bde.svg";